import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Copy, Check, Wallet } from "lucide-react";
import { toast } from "sonner";
import { GIVEAWAY } from "@/data/giveaway";

export const PaymentBox = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(GIVEAWAY.wallet);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = GIVEAWAY.wallet;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Wallet address copied! 🔥", {
      description: "Send SOL or USDC (SPL), then register your entry below.",
    });
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="glass rounded-lg p-6 md:p-8 border-gold/20"
      data-testid="payment-box"
    >
      <div className="flex flex-col md:flex-row gap-8 items-center">
        <div className="shrink-0 bg-white p-4 rounded-lg" data-testid="payment-qr">
          <QRCodeSVG value={GIVEAWAY.wallet} size={168} level="M" fgColor="#000000" />
        </div>

        <div className="flex-1 w-full">
          <div className="flex items-center gap-2 mb-2">
            <Wallet className="w-5 h-5 text-gold" />
            <span className="font-body text-sm font-bold uppercase tracking-widest text-gold">
              Send Payment To
            </span>
          </div>

          <div className="flex flex-wrap gap-2 mb-4">
            {GIVEAWAY.currencies.map((c) => (
              <span
                key={c}
                className="text-xs font-body font-bold uppercase tracking-wide border border-solana/40 text-solana rounded-full px-3 py-1"
              >
                {c}
              </span>
            ))}
            <span className="text-xs font-body font-bold uppercase tracking-wide border border-white/10 text-gray-300 rounded-full px-3 py-1">
              {GIVEAWAY.network}
            </span>
          </div>

          <button
            onClick={handleCopy}
            data-testid="payment-copy-wallet"
            className="group w-full flex items-center gap-3 bg-black/50 border border-white/10 rounded-md px-4 py-3.5 hover:border-gold/50 transition-colors duration-300"
          >
            <span className="font-mono text-xs sm:text-sm text-gray-200 break-all text-left flex-1">
              {GIVEAWAY.wallet}
            </span>
            {copied ? (
              <Check className="w-5 h-5 text-green-400 shrink-0" />
            ) : (
              <Copy className="w-5 h-5 text-gray-400 group-hover:text-gold transition-colors duration-300 shrink-0" />
            )}
          </button>

          <p className="mt-4 font-body text-sm text-gray-400 leading-relaxed">
            Scan the QR or copy the address. Only send{" "}
            <span className="text-white font-semibold">SOL</span> or{" "}
            <span className="text-white font-semibold">USDC on Solana</span>. After sending,
            paste your transaction hash in the form to lock in your entries.
          </p>
        </div>
      </div>
    </div>
  );
};
